module.exports = __webpack_public_path__ + "static/knittednavystripe1-2be83bd7e33eb4521a700be5fcf2b267.jpeg";